module.exports = __webpack_public_path__ + "img/seasonal_works_dark.212ffc13.svg";